import { IUserRepository, UserRepositoryData } from "../../../domain/adapter/repository/IUserRepository";
import { default as config } from "common/config/config";
import type { RoleDto } from "common/models/api/models/RoleDto";
import ObjectSessionStorageRespository from "../common/ObjectSessionStorageRepository";

export default class UserRepository extends ObjectSessionStorageRespository<UserRepositoryData> implements IUserRepository {
    constructor() {
        super(`${config.projectName}-user`);
    }

    getSelectedRole(): Promise<RoleDto | undefined> {
        return this.getByKey("selectedRole");
    }

    setSelectedRole(selectedRole: RoleDto): Promise<void> {
        return this.update({ selectedRole });
    }

    removeSelectedRole(): Promise<void> {
        return this.update({ selectedRole: undefined });
    }

    async clear(): Promise<void> {// skipcq: JS-0116
        super.clear(); // skipcq: JS-0328
    }
}
